module.exports = __webpack_public_path__ + "img/01.80f2c3f4.jpg";